import React, { useState } from 'react'

export default function LoginScreen({ onLogin }) {
  const [email, setEmail]     = useState('')
  const [senha, setSenha]     = useState('')
  const [erro, setErro]       = useState('')
  const [loading, setLoading] = useState(false)

  async function handleLogin(e) {
    e.preventDefault()
    setErro('')
    setLoading(true)
    try {
      const res = await fetch('/api/auth/login', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, senha })
      })
      const data = await res.json()
      if (!res.ok) {
        setErro(data.message || 'Credenciais inválidas')
        return
      }
      localStorage.removeItem('radio-ai-jwt')
      localStorage.setItem('radio-ai-user', JSON.stringify(data.perfil))
      onLogin(data.perfil)
    } catch {
      setErro('Erro de conexão com o servidor')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{
      minHeight: '100vh', background: 'var(--bg-base)',
      display: 'flex', alignItems: 'center', justifyContent: 'center'
    }}>
      <div style={{
        background: 'var(--bg-surface)', border: '1px solid var(--action-border)',
        borderRadius: 0, padding: 40, width: '100%', maxWidth: 400
      }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ fontSize: 28, fontWeight: 700, color: 'var(--text-primary)' }}>
            iafm.io
          </div>
          <div style={{ fontSize: 14, color: 'var(--text-secondary)', marginTop: 4 }}>
            Acesse o painel da sua rádio
          </div>
        </div>

        <form onSubmit={handleLogin}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontSize: 13, color: 'var(--text-secondary)', display: 'block', marginBottom: 6 }}>
              Email
            </label>
            <input
              type="email" value={email} onChange={e => setEmail(e.target.value)}
              placeholder="seu@email.com" required
              style={{
                width: '100%', padding: '10px 14px', borderRadius: 'var(--radius-md)',
                background: 'var(--bg-base)', border: '1px solid var(--border)',
                color: 'var(--text-primary)', fontSize: 14, boxSizing: 'border-box',
                outline: 'none'
              }}
            />
          </div>

          <div style={{ marginBottom: 24 }}>
            <label style={{ fontSize: 13, color: 'var(--text-secondary)', display: 'block', marginBottom: 6 }}>
              Senha
            </label>
            <input
              type="password" value={senha} onChange={e => setSenha(e.target.value)}
              placeholder="••••••••" required
              style={{
                width: '100%', padding: '10px 14px', borderRadius: 'var(--radius-md)',
                background: 'var(--bg-base)', border: '1px solid var(--border)',
                color: 'var(--text-primary)', fontSize: 14, boxSizing: 'border-box',
                outline: 'none'
              }}
            />
          </div>

          {erro && (
            <div style={{
              background: 'rgba(var(--error-rgb), 0.1)', border: '1px solid rgba(var(--error-rgb), 0.3)',
              borderRadius: 0, padding: '10px 14px',
              color: 'var(--error)', fontSize: 13, marginBottom: 16
            }}>
              {erro}
            </div>
          )}

          <button
            type="submit" disabled={loading}
            style={{
              width: '100%', padding: '11px', borderRadius: 'var(--radius-md)',
              background: loading ? 'var(--border)' : 'var(--action)',
              border: 'none', color: '#fff', fontSize: 15, fontWeight: 600,
              cursor: loading ? 'not-allowed' : 'pointer'
            }}
          >
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>

        <div style={{ fontSize: 13, color: 'var(--text-muted)', textAlign: 'center', marginTop: 24 }}>
          Para solicitar acesso entre em contato com iafm.io
        </div>
      </div>
    </div>
  )
}
